import { render, staticRenderFns } from "./DataLogModal.vue?vue&type=template&id=55f796cc&scoped=true"
import script from "./DataLogModal.vue?vue&type=script&lang=js"
export * from "./DataLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f796cc",
  null
  
)

export default component.exports